import CitySalaryPageTemplate from "@/components/CitySalaryPageTemplate";
import { CITY_SALARY_DATA } from "@/data/citySalaryData";

export default function SeniorSoftwareEngineerBangalore() {
  return <CitySalaryPageTemplate data={CITY_SALARY_DATA["senior-software-engineer-bangalore"]} />;
}
